export default "__VITE_ASSET__BSgi9Vak__"